(function () {
  "use strict";

  UserDetailsSidebarCtrl.$inject = ['$scope', 'mtypes', 'usersResource', 'authView', '$rootScope', '$location', 'modalHelper', 'compositeSearchData', 'manageUsersGrouping', 'trainerPrivilege'];
  angular
    .module('trainerWebApp.controllers')
    .controller('UserDetailsSidebarCtrl', UserDetailsSidebarCtrl);

  function UserDetailsSidebarCtrl($scope, mtypes, usersResource, authView, $rootScope, $location, modalHelper,
                                  compositeSearchData, manageUsersGrouping, trainerPrivilege) {
    $scope.serverCallInProgress = false;

    $scope.viewState = {
      showEditUserInfo: false
    };
    var userRole = trainerPrivilege.roles();

    $scope.canArchive = userRole.canArchiveUsers;
    $scope.canEditGroupMembership = userRole.canEditGroupMembership && !$scope.showArchived;
    $scope.canEditUserInfo = userRole.canEditUserInfo;

    $scope.$watch('selectedUser', function (newValue, oldValue) {
      $scope.selectedUserTabSelected = 'courses';

      if (!$scope.selectedUser)
        return;

      if ($scope.showTrainerPermissions() && needUserGroupsRestrictionsRefresh(newValue, oldValue)) {
        $scope.restrictedGroups = [];
        usersResource.getUserGroupsRestrictions($scope.selectedUser.id, function (restrictedGroups) {
          $scope.restrictedGroups = restrictedGroups;
        });
      }

      // Yeah crazy
      $scope.viewState.showEditUserInfo = (!(!$scope.canEditUserInfo || (!authView.isAdministrator() &&
      $scope.selectedUser.permissions == mtypes.userRole.administrator))) && !$scope.showArchived;

    });

    function needUserGroupsRestrictionsRefresh(newValue, oldValue) {
      if (!$scope.restrictedGroups) {
        return true;
      }
      if (!newValue || !oldValue) {
        return true;
      }
      if (newValue.id != oldValue.id) {
        return true;
      }
      return false;
    }

    $scope.showTrainerPermissions = function () {
      return $scope.selectedUser
        && authView.showUserPermissionsManagement()
        && ($scope.selectedUser.permissions == mtypes.userRole.reporter
        || $scope.selectedUser.permissions == mtypes.userRole.teamLead
        || $scope.selectedUser.permissions == mtypes.userRole.manager
        || $scope.selectedUser.permissions == mtypes.userRole.trainer);
    };

    $scope.showInviteCourseAndSeriesButton = function () {
      return !$scope.showArchived && userRole.canInviteUsers;
    };

    $scope.getCourseStatusColumn = function (course) {
      switch (course.courseStateStatus) {
        case mtypes.courseStateStatus.invited:
          return '<span title="Invited">--</span>';
        case mtypes.courseStateStatus.started:
          return '<span title="In progress">' + (course.progress ? Math.round(course.progress).toString() : '0') + '%</span>';
        case mtypes.courseStateStatus.completed:
          var icon = '', spanClass = '', title = '';

          switch (course.gradeStatus) {
            case mtypes.gradeStatus.notApplicable:
            case mtypes.gradeStatus.passed:
              spanClass = 'passed';
              icon = '<i class="icon-ok"></i>';
              title = 'Passed';
              break;
            case mtypes.gradeStatus.failed:
              spanClass = 'failed';
              title = 'Failed';
              icon = course.type == mtypes.courseType.series && !course.finalGrade ? '<i class="icon-remove"></i>' : '';
              break;
          }
          var scoreValue = course.finalGrade != null ? Math.round(course.finalGrade).toString() + '%' : '';
          return '<span class="' + spanClass + '" title="' + title + '">' + icon + scoreValue + '</span>';
        case mtypes.courseStateStatus.missedCompletionDeadline:
          return '<i class="icon-calendar missed" title="Missed completion deadline"></i>';
        default:
          return '';
      }
    };

    $scope.editUserInfo = function () {
      $scope.changeSidebar('pages/users/editUserInfoSidebar.html');
    };

    $scope.editGroups = function () {
      $scope.userGroupsGrouped = manageUsersGrouping.groupUserGroups([$scope.selectedUser], $scope.userGroupLookup);
      $scope.editUsersGroups($scope.userGroupsGrouped);
    };

    $scope.editCoursesAndSeries = function () {
      $scope.userCoursesGrouped = manageUsersGrouping.groupUserCourses([$scope.selectedUser], $scope.courseLookup);
      $scope.userSeriesGrouped = manageUsersGrouping.groupUserSeries([$scope.selectedUser], $scope.seriesLookup);
      $scope.editUsersCoursesAndSeries($scope.userCoursesGrouped, $scope.userSeriesGrouped);
    };

    $scope.isArrayEmpty = function (array) {
      return !array || array.length == 0;
    };

    $scope.showNoCoursesText = function () {
      return !$scope.selectedUser || !$scope.selectedUser.courses ||
        ($scope.isArrayEmpty($scope.selectedUser.courses.required) &&
        $scope.isArrayEmpty($scope.selectedUser.courses.optional) &&
        $scope.isArrayEmpty($scope.selectedUser.courses.completed));
    };

    $scope.showNoSeriesText = function () {
      return !$scope.selectedUser || !$scope.selectedUser.series ||
        ($scope.isArrayEmpty($scope.selectedUser.series.required) &&
        $scope.isArrayEmpty($scope.selectedUser.series.optional) &&
        $scope.isArrayEmpty($scope.selectedUser.series.completed));
    };

    $scope.archiveUser = function () {
      $scope.serverCallInProgress = true;
      usersResource.archiveUsers(
        [$scope.selectedUser.id],
        function (result) {
          $scope.refreshSelectedUserInfo(function () {
            $scope.serverCallInProgress = false;
          });
          $scope.cleanSelection();
        },
        function (err) {
          $scope.serverCallInProgress = false;
          var message = 'There was an error archiving the user. Please try again.';
          if (err && err.data && err.data.general)
            message = err.data.general;
          modalHelper.messageBox({title: 'Error Archiving User', message: message, buttons: [{label: 'OK'}]});
          return "cancelDefault";
        });
    };

    $scope.reactivateUser = function () {
      $scope.serverCallInProgress = true;
      usersResource.reactivateUsers(
        [$scope.selectedUser.id],
        function (result) {
          $scope.refreshSelectedUserInfo(function () {
            $scope.serverCallInProgress = false;
          });
          $scope.cleanSelection();
        },
        function (err) {
          $scope.serverCallInProgress = false;
          var message = 'There was an error reactivating the user. Please try again.';
          if (err && err.data && err.data.general)
            message = err.data.general;
          modalHelper.messageBox({title: 'Error Reactivating User', message: message, buttons: [{label: 'OK'}]});
          return "cancelDefault";
        });
    };

    $scope.canReactiveSelectedUser = function () {
      return $scope.canArchive
        && $scope.selectedUser
        && $scope.selectedUser.status == mtypes.userStatus.archived;
    };

    $scope.canArchiveSelectedUser = function () {
      return $scope.canArchive
        && $scope.selectedUser
        && $scope.selectedUser.status == mtypes.userStatus.active
        && !$scope.selectedUser.isOwner
        && (authView.isAdministrator() || $scope.selectedUser.permissions == mtypes.userRole.trainee)
        && ($rootScope.userId !== $scope.selectedUser.id);
    };

    $scope.managePermissions = function () {
      $scope.selectedUser.restrictedGroups = $scope.restrictedGroups
      $scope.restrictedGroups = null;
      $scope.changeSidebar('pages/users/managePermissionsSidebar.html');
    };

    $scope.goToManageGroup = function (group) {
      compositeSearchData.setSearchData('group', group.groupId);
      $location.path("/TMS/ManageGroups");
    };

    $scope.permissionsActions = function (group, $actionEvent) {
      $scope.filterByGroupId(group.groupId);
    };
  }

})();
